import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {Centre} from "../../../../../interfaces/Centres";
import {DialogRef} from "@angular/cdk/dialog";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CentreService} from "../../../../../services/centre.service";

@Component({
  selector: 'app-all-daily-child-occupancy',
  templateUrl: './all-daily-child-occupancy.component.html',
  styleUrls: ['./all-daily-child-occupancy.component.scss']
})
export class AllDailyChildOccupancyComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  allChild:any[] =[];
  dataSource!: MatTableDataSource<any>;
  selectedCenterName: string = '';
  centres$!: Observable<Centre[]>;
  selectedDate: any;
  centres: Centre[] = [];
  displayedColumns: string[] = ['srNo', 'childName', 'childCode', 'currentUnit']; // Define displayed columns
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private firestore : AngularFirestore,
              private mCentreService : CentreService,
              private dialog : DialogRef) {
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    this.selectedCenterName = this.data?.centreCode || 'Not Available';
    this.selectedDate = this.data?.date.toDate();
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe((centres) => {
      this.centres = centres;
    });

    this.firestore.collection<any>('dailyChildOccupancy', ref =>
      ref.where('centreCode', '==', this.data.centreCode).where('date', '==', this.data.date)
    ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      this.allChild = data[0].children;
      this.dataSource = new MatTableDataSource(this.allChild);
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  getCentreNameByCode(): string {
    const centerCode = this.data?.centreCode
    const centre = this.centres.find((c:any) => c.centreCode === centerCode);
    return centre ? centre.centreName : 'Unknown Centre';  // Return 'Unknown Centre' if not found
  }


  Close() {
    this.dialog.close()
  }
}
